import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Sparkles } from 'lucide-react';
export function GiftBackground() {
  const gifts = Array.from({
    length: 12
  });
  const sparkles = Array.from({
    length: 20
  });
  return <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-191">
      {/* Floating Gifts */}
      {gifts.map((_, i) => <motion.div key={`gift-${i}`} initial={{
      opacity: 0,
      y: Math.random() * 1000,
      x: Math.random() * 100 + '%',
      rotate: 0
    }} animate={{
      opacity: [0, 0.2, 0],
      y: [1000, -100],
      rotate: [0, 360],
      x: [Math.random() * 100 + '%', Math.random() * 100 + '%']
    }} transition={{
      duration: 15 + Math.random() * 10,
      repeat: Infinity,
      delay: Math.random() * 10,
      ease: 'linear'
    }} className="absolute text-violet-200" data-id="element-192">
          <Gift size={24 + Math.random() * 24} data-id="element-193" />
        </motion.div>)}

      {/* Twinkling Sparkles */}
      {sparkles.map((_, i) => <motion.div key={`sparkle-${i}`} initial={{
      opacity: 0,
      scale: 0,
      x: Math.random() * 100 + '%',
      y: Math.random() * 100 + '%'
    }} animate={{
      opacity: [0, 1, 0],
      scale: [0, 1, 0]
    }} transition={{
      duration: 2 + Math.random() * 3,
      repeat: Infinity,
      delay: Math.random() * 5
    }} className="absolute text-yellow-400" data-id="element-194">
          <Sparkles size={8 + Math.random() * 12} fill="currentColor" data-id="element-195" />
        </motion.div>)}

      {/* Gradient Overlays */}
      <div className="absolute inset-0 bg-gradient-to-b from-violet-50/50 via-transparent to-violet-50/50" data-id="element-196" />
    </div>;
}